import { FLOWS, useUploadFlow } from "hook/bailiff/document/flow/useUploadFlow";
import PreviewLoading from "./component/preview_loading";
import PreviewCompleted from "./component/preview_completed";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const UploadPreview = ({ audio }) => {
  // -------------------------- VAR -----------------------------
  const { flow } = useUploadFlow();
  const isFlow = flow === FLOWS.PREVIEW;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  if (!isFlow) return null;
  return (
    <>
      <PreviewCompleted audio={audio} />
    </>
  );
};
export default UploadPreview;
